import React from "react";
import Table from "../../../common/components/Table/Table";
import CollapsibleContainer from "../../../common/components/CollapsibleContainer";
import {Button, Icon} from "semantic-ui-react";
import { useDispatch } from "react-redux";

import {
    toggleModalBGPricingScheme,
    toggleAddBGCountryPricingModal, deleteBGPricingWarning, openEditBGCountryPricingModal
} from "veritas/billing-groups/actions/BillingGroupPricingActions";
import _ from "lodash";
import COUNTRIES from "../../../common/resources/countries.json";


export default function BillingGroupPricingTables({ billingGroupDetail, billingGroupID, pricingTables, canEdit, ...props }) {

    const dispatch = useDispatch();

    function handleAddPricingScheme() {
        dispatch(toggleModalBGPricingScheme(billingGroupID));
    }

    function handleAddCountry(e, {pricing_scheme, obj_key}) {
        e.preventDefault();
        dispatch(toggleAddBGCountryPricingModal(billingGroupID, pricing_scheme, obj_key));
    }

    function getTableHeaders(value, key) {
        let header = [<Table.Header key="countries">Country</Table.Header>];

        if (value?.pricing_scheme === "FLAT") {
            header.push(<Table.Header key="price">Price</Table.Header>)
        } else {
            value?.pricing_json.forEach(function (item) {
                let min = item.min;
                let max = item.max;
                if (item.min === 0) {
                    min = '<= ';
                }
                if (item.max === null) {
                    max = min;
                    min = '>= ';
                }
                if (item.min && item.max) {
                    min = min + ' - ';
                }
                header.push(<Table.Header key={'tier' + min + max}>{min}{max}</Table.Header>)
            });
        }
        if (canEdit) {
            header.push(<Table.Header key="edit-delete" className={"edit-records"}>
                <Button
                    obj_key={value?.pricing_json}
                    pricing_scheme={value?.pricing_scheme}
                    size={"mini"}
                    icon="add"
                    content="Add Country"
                    onClick={handleAddCountry}
                />
            </Table.Header>)
        }
        return header;
    }


    return (
        <div className={"country-pricing-tables"}>
            { canEdit ?
                <div className={"pricing-table-bar"}>
                    <Button
                        size={"mini"}
                        icon="add"
                        content="Add New Pricing Scheme"
                        onClick={handleAddPricingScheme}
                    />
                </div>
                : null}

            {pricingTables ?
                Object.entries(pricingTables).map(([key, value], idx) => (
                    <CollapsibleContainer
                        open={idx === 0}
                        title={'Pricing Scheme: ' + key}
                        id={idx}
                        key={idx}
                    >
                        <Table
                            headers={getTableHeaders(value[0], key)}
                            className={"pricing-table"}
                        >
                            {Object.values(value).map((item, idx) => (
                                <PricingTablesRow
                                    key={idx}
                                    countryRecord={item}
                                    canEdit={canEdit}
                                />
                            ))}
                        </Table>
                    </CollapsibleContainer>))
                : null}
        </div>
    )
}

function PricingTablesRow({countryRecord, canEdit, ...props }) {

    const dispatch = useDispatch();

    function countryLabel(code) {
        return _.result(_.find(COUNTRIES, {
            'value': code
        }), 'label');
    }

    function countryName() {
        const countryCode = countryRecord.country_code;
        return (
            <td>{countryCode + ' - ' + countryLabel(countryCode)}</td>
        );
    }
    function formattedCountryPrice() {
        const countryPrice = countryRecord.pricing_json;
        return (
            countryPrice.map((price, idx) => (
                <td key={idx}>{price.price}</td>
            ))
        )
    }

    function handleDeleteBGCountryPricing() {
        dispatch(deleteBGPricingWarning(countryRecord.country_pricing_id))
    }

    function handleEditBGCountryPricing() {
        dispatch(openEditBGCountryPricingModal(countryRecord))
    }

    function editDelete() {
        return (
            <td className={"edit-records"}>
                <Icon link
                      name="pencil alternate"
                      onClick={handleEditBGCountryPricing}
                />
                <Icon link
                      name="trash alternate outline"
                      onClick={handleDeleteBGCountryPricing}
                />
            </td>
        );
    }

    return (
        <tr key={countryRecord?.billing_group_id}>
            {countryName()}
            {formattedCountryPrice()}
            {canEdit && editDelete()}
        </tr>
    )
}
